import { z } from "zod/v4";
const PrefectureList = [
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
];
const PrefectureProperties = {
    北海道: {
        kana: "ホッカイドウ",
        roman: "hokkaido",
    },
    青森県: {
        kana: "アオモリケン",
        roman: "aomori",
    },
    岩手県: {
        kana: "イワテケン",
        roman: "iwate",
    },
    宮城県: {
        kana: "ミヤギケン",
        roman: "miyagi",
    },
    秋田県: {
        kana: "アキタケン",
        roman: "akita",
    },
    山形県: {
        kana: "ヤマガタケン",
        roman: "yamagata",
    },
    福島県: {
        kana: "フクシマケン",
        roman: "fukushima",
    },
    茨城県: {
        kana: "イバラキケン",
        roman: "ibaraki",
    },
    栃木県: {
        kana: "トチギケン",
        roman: "tochigi",
    },
    群馬県: {
        kana: "グンマケン",
        roman: "gunma",
    },
    埼玉県: {
        kana: "サイタマケン",
        roman: "saitama",
    },
    千葉県: {
        kana: "チバケン",
        roman: "chiba",
    },
    東京都: {
        kana: "トウキョウト",
        roman: "tokyo",
    },
    神奈川県: {
        kana: "カナガワケン",
        roman: "kanagawa",
    },
    新潟県: {
        kana: "ニイガタケン",
        roman: "niigata",
    },
    富山県: {
        kana: "トヤマケン",
        roman: "toyama",
    },
    石川県: {
        kana: "イシカワケン",
        roman: "ishikawa",
    },
    福井県: {
        kana: "フクイケン",
        roman: "fukui",
    },
    山梨県: {
        kana: "ヤマナシケン",
        roman: "yamanashi",
    },
    長野県: {
        kana: "ナガノケン",
        roman: "nagano",
    },
    岐阜県: {
        kana: "ギフケン",
        roman: "gifu",
    },
    静岡県: {
        kana: "シズオカケン",
        roman: "shizuoka",
    },
    愛知県: {
        kana: "アイチケン",
        roman: "aichi",
    },
    三重県: {
        kana: "ミエケン",
        roman: "mie",
    },
    滋賀県: {
        kana: "シガケン",
        roman: "shiga",
    },
    京都府: {
        kana: "キョウトフ",
        roman: "kyoto",
    },
    大阪府: {
        kana: "オオサカフ",
        roman: "osaka",
    },
    兵庫県: {
        kana: "ヒョウゴケン",
        roman: "hyogo",
    },
    奈良県: {
        kana: "ナラケン",
        roman: "nara",
    },
    和歌山県: {
        kana: "ワカヤマケン",
        roman: "wakayama",
    },
    鳥取県: {
        kana: "トットリケン",
        roman: "tottori",
    },
    島根県: {
        kana: "シマネケン",
        roman: "shimane",
    },
    岡山県: {
        kana: "オカヤマケン",
        roman: "okayama",
    },
    広島県: {
        kana: "ヒロシマケン",
        roman: "hiroshima",
    },
    山口県: {
        kana: "ヤマグチケン",
        roman: "yamaguchi",
    },
    徳島県: {
        kana: "トクシマケン",
        roman: "tokushima",
    },
    香川県: {
        kana: "カガワケン",
        roman: "kagawa",
    },
    愛媛県: {
        kana: "エヒメケン",
        roman: "ehime",
    },
    高知県: {
        kana: "コウチケン",
        roman: "kochi",
    },
    福岡県: {
        kana: "フクオカケン",
        roman: "fukuoka",
    },
    佐賀県: {
        kana: "サガケン",
        roman: "saga",
    },
    長崎県: {
        kana: "ナガサキケン",
        roman: "nagasaki",
    },
    熊本県: {
        kana: "クマモトケン",
        roman: "kumamoto",
    },
    大分県: {
        kana: "オオイタケン",
        roman: "oita",
    },
    宮崎県: {
        kana: "ミヤザキケン",
        roman: "miyazaki",
    },
    鹿児島県: {
        kana: "カゴシマケン",
        roman: "kagoshima",
    },
    沖縄県: {
        kana: "オキナワケン",
        roman: "okinawa",
    },
};
const PrefectureSchema = z.enum(PrefectureList);
export const Prefecture = {
    schema: PrefectureSchema,
    list: PrefectureList,
    ...PrefectureProperties,
};
//# sourceMappingURL=prefecture.js.map